import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query-v4';
import { queryClient } from 'react-scale/components/audits/ChatBulkAudit/ChatBulkAuditApi';
import { useParams } from 'react-router';
import { IUserJson } from '@scale/shared/types/user';
import ChatBulkAudit from 'react-scale/components/audits/ChatBulkAudit/ChatBulkAudit';

interface ChatBulkAuditPageProps {
  user: IUserJson;
  auditBatchIdOverride?: string;
}

const ChatBulkAuditPage: React.FC<ChatBulkAuditPageProps> = ({ user, auditBatchIdOverride }) => {
  const { auditBatchId } = useParams<{ auditBatchId?: string }>();
  return (
    <QueryClientProvider client={queryClient}>
      <ChatBulkAudit auditBatchId={auditBatchIdOverride ?? auditBatchId} user={user} />
    </QueryClientProvider>
  );
};

export default ChatBulkAuditPage;
